import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_scan-match-parts/artifacts/ukg9gyog_ps_logga_fl.png" 
              alt="Partsnap Logo" 
              className="footer-logo"
            />
            <span className="footer-logo-text">
              PART<span className="logo-accent">SNAP</span>
            </span>
            <p className="footer-tagline">{t('footerTagline')}</p>
          </div>
          
          <div className="footer-links">
            <Link to="/kontakt" className="footer-link">{t('contact')}</Link>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">{t('footerCopyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
